import React, { useEffect, useMemo, useRef, useState } from "react";
import styled, { css, createGlobalStyle } from "styled-components";
import { Button, Form } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";

const StyledButton = styled.button`
  padding: 10px 20px; /* 上下10px、左右15pxの内部パディングを設定 */
  border: none; /* ボーダーを消す */
  color: #0072bc; /* 文字色を設定 */
  background-color: #d5e5f2;
  cursor: pointer; /* カーソルをポインタに変更 */
  font-size: 12px; /* フォントサイズを設定 */
  border-radius: 5px; /* 角を丸くする */
  // margin-left: 3px;
  // margin-bottom: 5px;
  text-align: center; /* テキストを中央揃えにする */
  align-items: center; /* 垂直方向の中央揃え */
  justify-content: center; /* 水平方向の中央揃え */
  display: flex;

  ${(props) =>
    props.selected &&
    `
    color: white;
    background-color: #267ca7;
  `}

  @media (max-width: 768px) {
    font-size: 10px; // フォントを小さく
    padding: 8px 12px; // パディングも調整
  }
`;

// ✅ Register.js と同じサムネイルグリッド
const ThumbGrid = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  align-content: start;
`;

const ThumbItem = styled.div`
  width: 100%;
  min-height: 0;
`;

const ThumbButton = styled.button`
  all: unset; /* buttonの余計なCSSを全部消す */
  display: block;
  width: 100%;
  cursor: pointer;
`;

const ThumbSquare = styled.span`
  position: relative;
  display: block;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;

  /* 正方形を確実に作る */
  &::before {
    content: "";
    display: block;
    padding-top: 100%;
  }
`;

const ThumbImg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 25px;
  padding-bottom: 25px;
  background-color: #f5f5f5;
`;

const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

const DropdownButton = styled.button`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ced4da;
  background-color: white;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  text-align: left;
  color: black; /* 文字色を黒に設定 */
`;

const RegisterForm = styled(Form)`
  width: 500px;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: white;

  @media (max-width: 768px) {
    width: 90%; // スマホでは画面に収まるサイズ
    padding: 20px;
  }
`;

const SpacedTagsFormGroup = styled(Form.Group)`
  display: flex; /* Flexbox を有効にする */
  flex-wrap: wrap; /* コンテンツがコンテナの幅を超えた場合に折り返す */
  align-items: center; /* アイテムを垂直方向の中央に配置 */
  justify-content: flex-start; /* アイテムを水平方向の開始端に配置 */
  gap: 8px; /* ボタン間の隙間を設定 */
  margin-bottom: 5px;
`;

const RegisterButton = styled(Button)`
  width: 100%;
`;

const SpacedFormGroup = styled(Form.Group)`
  margin-bottom: 15px;
`;

const SpacedForm = css`
  width: 440px;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  height: 500px;
  resize: none;
  background-color: white;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const GlobalStyle = createGlobalStyle`
  .custom-form-control {
    ${SpacedForm}
  }
  .form-control {
    color: black;
  }
`;

const DropdownMenu = styled.ul`
  position: absolute;
  width: 100%;
  background-color: white;
  border: 1px solid #ced4da;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  padding: 0;
  margin: 0;
  list-style: none;
  z-index: 1000;

  ${({ $isOpen }) => (!$isOpen ? "display: none;" : "display: block;")}/* 修正 */
`;

const DropdownMenuItem = styled.li`
  padding: 10px;
  cursor: pointer;
  color: black;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const TagBox = styled.div`
  position: relative;
  margin-bottom: 8px;
  width: "100%";
`;
const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background: #fff;
  &:focus-within {
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.15);
  }
`;
const Chip = styled(StyledButton).attrs({ as: "span" })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  /* Chip はクリックで何もしない（× だけ反応） */
  cursor: default;
  user-select: none;

  /* ボタンホバー色などはそのままでもOKだが、Chipは変化させたくない場合は固定 */
  &:hover {
    background-color: #d5e5f2;
    color: #0072bc;
  }
`;

const styles = {
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
    padding: "16px", // スマホで端ギリギリ回避
  },
  modalContent: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    width: "min(640px, 92vw)",
    maxHeight: "min(85vh, calc(100dvh - 32px))",
    boxSizing: "border-box",
    overflow: "hidden",
    minHeight: 0,
  },
  scrollArea: {
    flex: "1 1 auto",
    minHeight: 0,
    overflowX: "hidden",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    overscrollBehavior: "contain",
    padding: "4px 2px 0",
  },
};

const Input = styled.input`
  flex: 1; /* 残りスペースを全部使う */
  width: 100%; /* 横幅いっぱいに */
  min-width: 0; /* flexboxで縮む時に制限を外す */
  border: none;
  outline: none;
  font-size: 14px;
`;

export function TagFreeInput({ value, onChange, maxTags = 10, placeholder = "タグを入力（カンマ/スペース/Enter/Tabで確定）" }) {
  const [q, setQ] = useState("");
  const [isComposing, setIsComposing] = useState(false);

  const names = useMemo(() => new Set((value || []).map((v) => v.trim().toLowerCase())), [value]);

  const canAddMore = (value || []).length < maxTags;

  const pushTag = (name) => {
    if (!canAddMore) return;
    const n = (name || "").trim();
    if (!n) return;
    const norm = n.toLowerCase();
    if (names.has(norm)) return;
    onChange([...(value || []), n]);
  };

  const commitFromBuffer = (buffer) => {
    const parts = (buffer || "")
      .split(/[,\s]+/)
      .map((s) => s.trim())
      .filter(Boolean);
    let current = [...(value || [])];
    for (const p of parts) {
      if (current.length >= maxTags) break;
      const norm = p.toLowerCase();
      if (!current.map((x) => x.toLowerCase().trim()).includes(norm)) {
        current.push(p);
      }
    }
    onChange(current);
  };

  const handleKeyDown = (e) => {
    if (isComposing) return;

    if (e.key === "," || e.key === " " || e.key === "Enter" || e.key === "Tab") {
      if (q.trim()) {
        e.preventDefault();
        commitFromBuffer(q);
        setQ("");
      } else if (e.key === "Backspace" && (value || []).length > 0) {
        e.preventDefault();
        const next = [...value];
        next.pop();
        onChange(next);
      }
    } else if (e.key === "Backspace" && !q && (value || []).length > 0) {
      const next = [...value];
      next.pop();
      onChange(next);
    }
  };

  const handlePaste = (e) => {
    const text = e.clipboardData.getData("text");
    if (!text) return;
    if (/[,\s]/.test(text)) {
      e.preventDefault();
      commitFromBuffer((q + " " + text).trim());
      setQ("");
    }
  };

  return (
    <TagBox>
      <ChipRow>
        {(value || []).map((t, i) => (
          <Chip key={`${t}-${i}`}>
            #{t}
            <span
              role="button"
              aria-label={`${t} を削除`}
              onClick={() => onChange(value.filter((_, idx) => idx !== i))}
              style={{ cursor: "pointer", marginLeft: "4px", fontWeight: "bold", fontSize: "14px" }}
            >
              ×
            </span>
          </Chip>
        ))}
        <Input value={q} placeholder={canAddMore ? placeholder : `最大 ${maxTags} 個まで`} onChange={(e) => setQ(e.target.value)} onKeyDown={handleKeyDown} onPaste={handlePaste} onCompositionStart={() => setIsComposing(true)} onCompositionEnd={() => setIsComposing(false)} />
      </ChipRow>
    </TagBox>
  );
}

const EditGoalRegister = () => {
  const [selectedTags, setSelectedTags] = useState([]);
  const maxTags = 10; // タグの最大選択数
  const [isOpen, setIsOpen] = useState(false); // メニューが開いているかの状態を管理
  const [selectedOption, setSelectedOption] = useState("選択してください"); // 選択されたオプションの状態を管理
  const [isModalOpen, setIsModalOpen] = useState(false); // モーダルの開閉状態管理
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [errMessage, setErrMessage] = useState(null); // エラーメッセージ
  const [showErrorModal, setShowErrorModal] = useState(false); // 状態管理
  const [eventDate, setEventDate] = useState(null);

  // ✅ Register.js と同じ manifest 方式
  const MANIFEST_URL = "/img/manifest.json";

  // manifest のキー（フォルダ名）に対応させる
  const categoryImageFolderMap = {
    sports: ["sports"],
    company: ["company", "entrepreneurship"],
    entrepreneurship: ["entrepreneurship", "company"],
    career: ["company", "entrepreneurship", "sports"],
    romance: ["romance"],
    study: ["literature", "self_satisfaction", "company"],
    self_satisfaction: ["self_satisfaction", "literature"],
    literature: ["literature", "self_satisfaction"],
  };

  async function loadCategoryImages(mappedCategory) {
    const url = `${MANIFEST_URL}?v=${Date.now()}`; // キャッシュ回避
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) throw new Error(`manifest.json fetch failed: ${res.status}`);

    const manifest = await res.json();

    // PWA manifest を踏んだ等の事故防止（Register.jsと同じ思想）
    const expectedKeys = ["sports", "company", "entrepreneurship", "romance", "self_satisfaction", "literature"];
    if (!expectedKeys.some((k) => k in manifest)) {
      throw new Error("Unexpected manifest.json (not image manifest)");
    }

    const folderKeys = categoryImageFolderMap[mappedCategory];
    if (!folderKeys || folderKeys.length === 0) return [];

    return [...new Set(folderKeys.flatMap((key) => manifest[key] || []))];
  }

  const location = useLocation();
  const navigate = useNavigate();
  const goal = location.state?.goal || {};

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleImageClick = (imagePath) => {
    setSelectedImage(imagePath);
    closeModal();
  };

  const handleTagButtonClick = (event, tag) => {
    event.preventDefault();

    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag));
    } else {
      // タグが最大数に達していない場合、追加する
      if (selectedTags.length < maxTags) {
        setSelectedTags([...selectedTags, tag]);
      }
    }
  };

  const categoryMap = {
    sports: "スポーツ",
    company: "会社",
    entrepreneurship: "起業",
    romance: "恋愛",
    self_satisfaction: "自己満足",
    literature: "漫画、文学",
  };

  const reverseCategoryMap = {
    スポーツ: "sports",
    会社: "company",
    起業: "entrepreneurship",
    恋愛: "romance",
    自己満足: "self_satisfaction",
    "漫画、文学": "literature",
  };

  categoryMap.career = "職業・キャリア";
  categoryMap.study = "資格・勉強";
  reverseCategoryMap["職業・キャリア"] = "career";
  reverseCategoryMap["資格・勉強"] = "study";

  categoryMap.career = "\u8077\u696d\u30fb\u30ad\u30e3\u30ea\u30a2";
  categoryMap.study = "\u8cc7\u683c\u30fb\u52c9\u5f37";
  reverseCategoryMap["\u8077\u696d\u30fb\u30ad\u30e3\u30ea\u30a2"] = "career";
  reverseCategoryMap["\u8cc7\u683c\u30fb\u52c9\u5f37"] = "study";

  const ChapterSelectButton = styled(Button)`
    background-color: gray;
    border: none;
    width: 35%;
  `;

  const BlockLabel = styled(Form.Label)`
    display: block;
    margin-bottom: 5px;
    flex-basis: 100%;
  `;

  useEffect(() => {
    if (goal.category) {
      // goal.category は英語キー（sports 等）前提
      setSelectedOption(categoryMap[goal.category] || "選択してください");

      // ✅ ここで画像一覧をmanifestから読む
      loadCategoryImages(goal.category)
        .then((imgs) => setImageList(imgs))
        .catch((e) => {
          console.error(e);
          setImageList([]);
          toast.error("画像一覧の取得に失敗しました");
        });
    }

    // tags_detail はAPIから返る配列（tags は write-only なので使えない）
    const existingTags = goal.tags_detail || goal.tags;
    if (existingTags) {
      if (Array.isArray(existingTags)) {
        setSelectedTags(existingTags);
      } else if (typeof existingTags === "string" && existingTags.trim()) {
        setSelectedTags(existingTags.split(",").map((tag) => tag.trim()));
      }
    }

    if (goal.image_url) {
      setSelectedImage(goal.image_url);
    }
  }, [goal]);

  useEffect(() => {
    setEventDetails((prevDetails) => ({
      ...prevDetails,
      目標イメージ画像: selectedImage, // 画像のパスを追加
    }));
  }, [selectedImage]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.key]);

  const targetRef = useRef(null);

  const [eventDetails, setEventDetails] = useState({
    無謀な夢のID: goal.id || "",
    無謀な夢: goal.title || "",
    目標実現日: goal.deadline || "",
    目標イメージ画像: goal.image_url || "",
    カテゴリ: goal.category || "",
    タグ: goal.tags_detail || goal.tags || "",
    無謀な夢の詳細: goal.description || "",
  });

  const handleInputChange = (e) => {
    setEventDetails({
      ...eventDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleOptionClick = (category) => {
    setSelectedOption(category);
    const mappedCategory = reverseCategoryMap[category]; // 日本語を英語に変換
    setEventDetails((prevDetails) => ({
      ...prevDetails,
      カテゴリ: category, // カテゴリを更新
    }));
    setIsOpen(false);

    const handleOptionClick = (category) => {
      setSelectedOption(category);

      const mappedCategory = reverseCategoryMap[category]; // 日本語 → 英語
      setEventDetails((prevDetails) => ({
        ...prevDetails,
        カテゴリ: category,
      }));
      setIsOpen(false);

      // ✅ manifestから画像一覧取得
      loadCategoryImages(mappedCategory)
        .then((imgs) => setImageList(imgs))
        .catch((e) => {
          console.error(e);
          setImageList([]);
          toast.error("画像一覧の取得に失敗しました");
        });

      // 画像選択をリセット
      setSelectedImage(null);
    };
    // 画像選択をリセット
    setSelectedImage(null);
  };

  const categories = ["スポーツ", "会社", "起業", "恋愛", "自己満足", "漫画、文学"];

  categories.push("職業・キャリア", "資格・勉強");

  useEffect(() => {
    if (!location.state?.goal) {
      navigate("/MyPage", {
        replace: true,
        state: { message: "編集する夢をもう一度選んでください" },
      });
    }
  }, [location.state, navigate]);

  const handleClick = () => {
    const missingFields = [];
    if (!eventDetails["無謀な夢"]) missingFields.push("タイトル");
    if (!eventDetails["目標実現日"]) missingFields.push("目標実現日");
    if (!eventDetails["目標イメージ画像"] || !selectedImage) missingFields.push("イメージ画像");
    if (!eventDetails["カテゴリ"]) missingFields.push("カテゴリ");
    if (selectedTags.length === 0) missingFields.push("タグ");
    if (!eventDetails["無謀な夢の詳細"]) missingFields.push("夢の詳細");

    if (missingFields.length > 0) {
      const message = `${missingFields.join("、")}を入力してください`;
      setErrMessage(message);
      toast.error(message);
      return;
    }

    document.activeElement?.blur?.();
    navigate("/EditGoalRegisterConfirmView", {
      state: {
        eventDetails: {
          ...eventDetails,
          タグ: selectedTags, // 配列のまま渡す
        },
      },
    });
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen); // メニューの表示／非表示を切り替え
  };

  return (
    <React.StrictMode>
      <GlobalStyle />
      <Container>
        <RegisterForm>
          <SpacedFormGroup controlId="formBasicEvent" ref={targetRef}>
            <Form.Label>
              無謀な夢 <span className="badge bg-danger">必須</span>
            </Form.Label>
            <Form.Control readOnly defaultValue={eventDetails.無謀な夢} name="無謀な夢" maxLength="20" type="text" placeholder="無謀な夢" onChange={handleInputChange} required style={{ backgroundColor: "#e9ecef", color: "#6c757d", cursor: "not-allowed" }} />
          </SpacedFormGroup>

          <SpacedFormGroup controlId="formBasicEventEndDate">
            <Form.Label>
              目標実現日 <span className="badge bg-danger">必須</span>
            </Form.Label>
            <Form.Control name="目標実現日" type="date" placeholder="目標実現日" value={eventDetails.目標実現日} onChange={handleInputChange} required />
          </SpacedFormGroup>

          <Form.Label>
            カテゴリ <span className="badge bg-danger">必須</span>
          </Form.Label>
          <DropdownContainer>
            <DropdownButton type="button" onClick={toggleDropdown} className="dropdown-button">
              {selectedOption}
            </DropdownButton>
            {isOpen && (
              <DropdownMenu className="dropdown-menu" $isOpen={isOpen}>
                {categories.map((category, index) => (
                  <DropdownMenuItem key={index} onClick={() => handleOptionClick(category)} onChange={handleInputChange}>
                    {category}
                  </DropdownMenuItem>
                ))}
              </DropdownMenu>
            )}
          </DropdownContainer>

          <br />
          <Form.Label>
            目標イメージ画像 <span className="badge bg-danger">必須</span>
          </Form.Label>
          <br />
          <ChapterSelectButton
            onClick={openModal}
            disabled={selectedOption === "選択してください"}
            variant="primary"
            size="lg"
            className="w-100 text-center d-flex align-items-center justify-content-center"
            style={{ minWidth: "120px", whiteSpace: "nowrap", fontSize: "1.2rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "#282c34" }}
            value={eventDetails.目標イメージ画像}
          >
            画像を選択する
          </ChapterSelectButton>

          {/* 選択された画像の表示 */}
          {selectedImage && (
            <div style={{ marginTop: "20px" }}>
              <Form.Label>選択された画像</Form.Label>
              <br />
              <img src={selectedImage} alt="選択された画像" style={{ width: "100px", height: "100px", border: "1px solid gray" }} />
            </div>
          )}

          {/* モーダル（ポップアップ） */}
          {isModalOpen && (
            <div style={styles.modal}>
              <div style={styles.modalContent}>
                <Form.Label>画像を選択してください</Form.Label>
                <div style={styles.scrollArea}>
                  <ThumbGrid>
                    {imageList.map((imagePath) => (
                      <ThumbItem key={imagePath}>
                        <ThumbButton type="button" onClick={() => handleImageClick(imagePath)}>
                          <ThumbSquare>
                            <ThumbImg src={imagePath} alt="選択できる画像" />
                          </ThumbSquare>
                        </ThumbButton>
                      </ThumbItem>
                    ))}
                  </ThumbGrid>
                </div>
                {/* モーダルを閉じるボタン */}
                <Button onClick={closeModal} variant="primary" type="submit" size="lg" className="w-100 text-center d-flex align-items-center justify-content-center" style={{ marginTop: "20px", minWidth: "120px", whiteSpace: "nowrap", fontSize: "1.2rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "#282c34" }}>
                  キャンセル
                </Button>
              </div>
            </div>
          )}
          <br />

          <br />

          <SpacedTagsFormGroup controlId="formBasicEventTags">
            <BlockLabel>
              #タグ（最大10個） <span className="badge bg-secondary">任意</span>
            </BlockLabel>
            {/* 修正前のタグを表示 */}
            {(goal.tags_detail || goal.tags) && (
              <div style={{ marginBottom: "8px", padding: "8px", backgroundColor: "#f8f9fa", borderRadius: "6px", border: "1px solid #e0e0e0" }}>
                <span style={{ fontSize: "12px", color: "#888", display: "block", marginBottom: "4px" }}>修正前のタグ:</span>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {(Array.isArray(goal.tags_detail) ? goal.tags_detail : (goal.tags || "").split(",").map(t => t.trim()).filter(Boolean)).map((t, i) => (
                    <span key={i} style={{ padding: "4px 10px", backgroundColor: "#e9ecef", borderRadius: "4px", fontSize: "12px", color: "#6c757d" }}>#{t}</span>
                  ))}
                </div>
              </div>
            )}
            <BlockLabel>
              <TagFreeInput value={selectedTags} onChange={setSelectedTags} maxTags={maxTags} />
            </BlockLabel>
            <BlockLabel>よく使われているタグから選択</BlockLabel>
            <SpacedTagsFormGroup>
              {[
                "エンジニア",
                "作家",
                "CEO",
                "起業",
                "投資",
                "環境保護",
                "動物福祉",
                "恋人が欲しい",
                "ダイエット",
                "歌手",
                "登山",
                "メジャーリーグ",
                "アイドル",
                "セリアA",
                "coffee",
                "パン",
                "世界平和",
                "バロンドール",
                "ターナー賞",
                "パリコレ",
                "グラミー賞",
                "オスカー",
                "ノーベル文学賞",
                "フィールズ賞",
                "M1優勝",
                "ダービージョッキー",
                "仮面ライダー",
                "漫画家",
                "復興",
                "世界一周",
                "ファンド",
              ].map((tag) => (
                <StyledButton
                  key={tag}
                  type="button"
                  selected={selectedTags.includes(tag)} // 選択されているかどうかをチェック
                  onClick={(e) => handleTagButtonClick(e, tag)}
                >
                  #{tag}
                </StyledButton>
              ))}
            </SpacedTagsFormGroup>
            {/* タグの選択数が5つに達している場合、警告メッセージを表示 */}
            {selectedTags.length >= maxTags && <p style={{ color: "red" }}>選択可能なタグは最大10つまでです。</p>}
          </SpacedTagsFormGroup>
          <SpacedFormGroup controlId="formBasicEventDetails">
            <Form.Label>
              無謀な夢の詳細 <span className="badge bg-danger">必須</span>
            </Form.Label>
            <Form.Control name="無謀な夢の詳細" as="textarea" type="text" placeholder="無謀な夢の詳細" className="custom-form-control" value={eventDetails.無謀な夢の詳細} onChange={handleInputChange} />
          </SpacedFormGroup>

          <RegisterButton onClick={handleClick} className="w-100 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "120px", whiteSpace: "nowrap", fontSize: "1.2rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "#282c34" }}>
            確認画面へ
          </RegisterButton>
          {showErrorModal && (
            <div
              style={{
                position: "fixed",
                top: "30%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.3)",
                zIndex: 9999,
              }}
            >
              <p>{errMessage}</p>
              <button
                onClick={() => {
                  setShowErrorModal(false);
                  navigate("Register", { state: { fromEdit: true } });
                }}
                style={{ borderRadius: "8px", color: "#000000", marginTop: "10px", padding: "8px 16px" }}
              >
                閉じる
              </button>
            </div>
          )}
        </RegisterForm>
        <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnFocusLoss draggable pauseOnHover />
      </Container>
    </React.StrictMode>
  );
};

export default EditGoalRegister;
